import { ChangeDetectorRef, Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { CommmonUtil } from '../utils/common.util';
import { StateService } from '../../services/history.state.service';
import { Router } from '@angular/router';
import { environment } from '../../../../../environments/environment';
import { WebPubSubService } from '../../../../services/WebPubSubService';
import { CommonMessageService } from '../../../../services/messageCountService';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.css',
  encapsulation: ViewEncapsulation.None,
})
export class DashboardComponent implements OnInit, OnDestroy {
  dashbaordCounts: any = {};
  PatientPhoneNo:any;
  isPatientDOB: boolean = false;
  metaData:any;
  patientID_npi:any;
  isSecurePatientComm!:boolean;
  private destroy$ = new Subject<void>();

  constructor(
    private _router: Router,
    private stateService: StateService,
    private commmonUtil:CommmonUtil,
    private cdr: ChangeDetectorRef,
    private webPubSubService: WebPubSubService,
    private commonMessageService:CommonMessageService){
  }

  ngOnInit() {
    this.loadDashboardCounts();

    // Subscribe to real-time count updates from other components (history, etc.)
    this.stateService.dashboardCounts$.pipe(
      takeUntil(this.destroy$)
    ).subscribe(counts => {
      if (counts) {
        this.dashbaordCounts = counts;
        this.isPatientDOB = counts?.isTodayBirthday;
        this.cdr.detectChanges();
      }
    });

    this.isSecurePatientComm = environment.isSecurePatientComm;
    this.metaData = JSON.parse(localStorage.getItem('MetaData') as string);
      if(this.metaData && this.isSecurePatientComm){
        this.patientID_npi = JSON.stringify(this.metaData?.patientId) +'_'+ this.metaData?.pharmacyNpi;
        this.webPubSubService.initializePatientWebSocket(this.patientID_npi)
          .catch(err => console.error('[Dashboard] WebSocket init failed (chat unavailable):', err));
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  showSection(section: string) {
    this.stateService.setActiveSection(section);
    this._router.navigate(['/PendingPayments']);
  }
  async loadDashboardCounts() {
    // Show cached counts immediately so dashboard isn't blank
    const cached = localStorage.getItem('DboardCounts');
    if (cached) {
      try {
        const cachedCounts = JSON.parse(cached);
        this.dashbaordCounts = cachedCounts;
        this.isPatientDOB = cachedCounts?.isTodayBirthday;
        this.cdr.detectChanges();
      } catch (e) {}
    }

    try {
      const counts = await this.commmonUtil.getCounts();
      this.commonMessageService.getCounts();
      if (counts) {
        this.dashbaordCounts = counts;
        this.isPatientDOB = counts?.isTodayBirthday;
        // Broadcast so all components stay in sync
        this.stateService.setDashboardCounts(counts);
        this.cdr.detectChanges();
      }
    } catch (error) {
      console.error('[Dashboard] Failed to load counts:', error);
    }
  }

}
